export default "__VITE_ASSET__1152fd76__"